// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import { gql } from '@apollo/client';
export type PartnerAccountDetailFragment = { __typename?: 'PartnerAccount', type: string, organizationName: string, accountNumber: string, partnerNumber: string, streetAddresses: Array<string>, attentionTo: string, department: string, buildingRoom: string, city: string, state: string, postalCode: string, country: string, isDefault: boolean, salesOrg: string, customerServiceNotes?: string | null };

export const PartnerAccountDetailFragmentDoc = gql`
    fragment PartnerAccountDetail on PartnerAccount {
  type
  organizationName
  accountNumber
  partnerNumber
  streetAddresses
  attentionTo
  department
  buildingRoom
  city
  state
  postalCode
  country
  isDefault
  salesOrg
  customerServiceNotes
}
    `;